<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Retailers
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="addSaleAgent.dialog = true">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.fullname`]="{ item }">
              {{ `${item.firstName} ${item.middleName} ${item.lastName}` }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn x-small color="pink" dark @click="editDrawDetail(item)">
                Edit</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <AddSalesAgentDialog
      :dialog="addSaleAgent.dialog"
      @close="addSaleAgent.dialog = !addSaleAgent.dialog"
      @response="addSalesAgentResponse"
    ></AddSalesAgentDialog>
  </v-container>
</template>

<script>
import moment from "moment";
import AddSalesAgentDialog from "../dialogs/AddSalesAgentDialog.vue";
export default {
  name: "SalesAgent",
  components: {
    AddSalesAgentDialog,
  },
  data() {
    return {
      addSaleAgent: {
        dialog: false,
      },

      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        
        headers: [
          {
            text: "Full name",
            align: "start",
            value: "retailerfullname",
          },
          {
            text: "Mobile Number",
            align: "start",
            value: "retailerMobileNumber",
          },
          {
            text: "Email",
            align: "start",
            value: "Email",
          },

          {
            text: "Sex",
            align: "start",
            value: "Sex",
          },
          {
            text: "Birthday",
            align: "start",
            value: "Birthday",
          },

          {
            text: "Address",
            align: "start",
            value: "address",
          },
          {
            text: "Prepaid Fiber Account No.",
            align: "start",
            value: "prepaidFiberAccountNumber",
          },
          {
            text: "Registration Date",
            align: "start",
            sortable: false,
            value: "registrationDate",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
          // {
          //   text: "Actions",
          //   align: "center",
          //   sortable: false,
          //   value: "actions",
          // },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/acquisition/retailers")
        .then((response) => {
          console.log(response);
          const newArr = response.data.data.retailers;
          console.log(newArr);
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    addSalesAgentResponse(res) {
      if (res) {
        this.getList();
        this.addSaleAgent.dialog = false;
      }
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
